<div class="single-period-container">
  <div class="flex p-x-1 w-100 flex-end m-b-2">
    <div class="controls flex align-items-center h-full m-t-xs m-r-2">
      <em class="fa fa-light fa-arrow-alt-circle-left"
          (click)="canNavigateBack && navigatePrevious()"
          [class.disabled]="!canNavigateBack"
          [class.text-muted]="!canNavigateBack"
          tooltip="{{ 'TOOLTIPS.prev_period' | translate }}">
      </em>
      <label class="m-b-0 m-x-1" [style.font-size]="'medium'">{{ editedPayPeriod?.attributes?.transid | translate }}</label>
      <em class="fa fa-light fa-arrow-alt-circle-right"
          (click)="canNavigateForward && navigateNext()"
          [class.disabled]="!canNavigateForward"
          [class.text-muted]="!canNavigateForward"
          tooltip="{{ 'TOOLTIPS.next_period' | translate }}">
      </em>
    </div>
    <button type="button" class="btn primary btn-sm btn-bar-xs h-full m-t-xs" (click)="createVariable()" *ngIf="!readOnly">
      <em class="fa fa-light fa-plus-circle"></em>
      <span class="hidden-sm-down m-l-sm">{{'NOTIFICATIONS.add' | translate}}</span>
    </button>
  </div>
  <div *ngIf="!localLoading; else loadingTemplate">
    <table class="text-sm" aria-label="variable_elements">
      <colgroup>
        <col class="td-col-w-5">
        <col class="td-col-w-45">
        <col class="td-col-w-10">
        <col class="td-col-w-10">
        <col class="td-col-w-10">
        <col class="td-col-w-10">
        <col class="td-col-w-auto">
      </colgroup>
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">{{'PAYROLL_RESULT.name' | translate}}</th>
          <th scope="col" class="text-center">{{ (previousPayPeriod?.attributes?.transid | translate) || '-' }}</th>
          <th scope="col" class="text-center">{{ editedPayPeriod?.attributes?.transid | translate }}</th>
          <th scope="col" class="text-center">{{ (nextPayPeriod?.attributes?.transid | translate) || '-' }}</th>
          <th scope="col">{{'FORMS.Unit' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let type of variableElements | keys | sort">
          <gp-variable-elements-multiple-payperiod-row
            [style.display]="'contents'"
            [type]="type"
            [readOnly]="readOnly"
            [editedPayPeriod]="editedPayPeriod"
            [previousPayPeriod]="previousPayPeriod"
            [nextPayPeriod]="nextPayPeriod"
            [variableElements]="variableElements[type]"
            [contract]="contract"
            (onEditElement)="editVariable($event)"
            (variableElementDeletedNew)="variableDeletedNew($event)"
            (variableElementDeleted)="variableDeleted($event)"
            (isDirty)="markAsDirty($event)">
          </gp-variable-elements-multiple-payperiod-row>
        </ng-container>
        <tr *ngIf="(!variableElements || !objectKeys(variableElements)?.length) && (!loading && !localLoading)">
          <td colspan="7">
            <div class="font-weight-bold text-center">
              {{'PAYROLL_PREPARE.variables_not_found' | translate}}
            </div>
          </td>
        </tr>
        <tr *ngIf="localLoading">
          <td colspan="7">
            <div class="flex flex-center-x-y">
              <em class="fa fa-light fa-spinner fa-spin"></em>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="flex flex-center-x-y">
    <div class="flex-center-x-y">
      <em class="fa fa-light fa-spin fa-spinner">
      </em>
    </div>
  </div>
</ng-template>
